import { j as o } from "../../jsx-runtime-p91LotPX.mjs";
import r from "./style.js";
function m(t) {
  return /* @__PURE__ */ o.jsx(r, { ...t });
}
export {
  m as GrowButton
};
//# sourceMappingURL=AntButton.js.map
